export {default} from './ChatForm';



// WEBPACK FOOTER //
// ./src/containers/ChatForm/index.ts